import { attributesConditionsMatch } from 'shared-helpers/customAttributes';

import type { RequestUser, UserCustomAttribute } from 'shared-types';

interface Params {
  allowUserPermissionForAdmin?: boolean;
  user: RequestUser;
  userCustomAttribute: UserCustomAttribute;
}

const canUserCustomAttributeBeViewed = ({
  allowUserPermissionForAdmin,
  user,
  userCustomAttribute
}: Params) => {
  if (
    user?.roles.includes('superadmin') &&
    userCustomAttribute.permissions?.view.superadmin.value
  ) {
    return userCustomAttribute.permissions.view.superadmin.conditions?.length
      ? attributesConditionsMatch({
          conditions:
            userCustomAttribute.permissions.view.superadmin.conditions,
          user,
          customAttributeValues: user.customAttributes
        })
      : true;
  }

  if (
    user?.roles.includes('admin') &&
    !user.roles.includes('superadmin') &&
    userCustomAttribute.permissions?.view.admin.value
  ) {
    return userCustomAttribute.permissions.view.admin.conditions?.length
      ? attributesConditionsMatch({
          conditions: userCustomAttribute.permissions.view.admin.conditions,
          user,
          customAttributeValues: user.customAttributes
        })
      : true;
  }

  if (
    (user?.roles.includes('user') || user?.roles.includes('guest')) &&
    ((!user.roles.includes('admin') && !user.roles.includes('superadmin')) ||
      allowUserPermissionForAdmin) &&
    userCustomAttribute.permissions?.view.user.value
  ) {
    return userCustomAttribute.permissions.view.user.conditions?.length
      ? attributesConditionsMatch({
          conditions: userCustomAttribute.permissions.view.user.conditions,
          user,
          customAttributeValues: user.customAttributes
        })
      : true;
  }

  return false;
};

export default canUserCustomAttributeBeViewed;
